import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Popover, PopoverSurface, PopoverTrigger } from "@fluentui/react-components";
import { useState, useEffect } from "react";
/**
 * PositionedPopover component that shows a popover at specific coordinates
 * @param props - The component props
 * @returns The positioned popover component
 */
export const PositionedPopover = (props) => {
    PositionedPopover.displayName = "PositionedPopover";
    const [open, setOpen] = useState(false);
    useEffect(() => {
        setOpen(props.visible);
    }, [props.visible, props.x, props.y]);
    const handleOpenChange = (_, data) => {
        setOpen(data.open);
        if (!data.open) {
            props.hide();
        }
    };
    return (_jsxs(Popover, { open: open, onOpenChange: handleOpenChange, positioning: {
            position: "below", // Places the popover directly below the trigger element
            autoSize: "height-always", //Automatically adjusts the popover height to fit within the viewport
            fallbackPositions: ["above", "after", "before"], //If the primary position doesn't fit, automatically tries these positions in order
        }, withArrow: false, children: [_jsx(PopoverTrigger, { children: _jsx("div", { style: {
                        position: "absolute",
                        left: `${props.x}px`,
                        top: `${props.y}px`,
                        visibility: "hidden",
                    } }) }), _jsx(PopoverSurface, { children: props.children })] }));
};
//# sourceMappingURL=positionedPopover.js.map